import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useAuth} from "../../context/auth";
import {useGlobalNotificationMessage} from "../../context/message";
import {Form, Formik} from "formik";
import {userProfileRequestSchema} from "../../utils/schemas";
import PageTitle from "../../components/page-title";
import FormGroup from "../../components/form-group";
import {useUserService} from "../../services/user-service";
import Loading from "../../components/loading";
import {useCountryService} from "../../services/country-service";
import {LocaleList} from "../../utils/constants";
import {useTimezoneService} from "../../services/timezone-service";
import ContactCell from "../../components/contact-cell";
import AddEditContactModal from "./add-edit-contact-modal";
import AddEditAddressModal from "./add-edit-address-modal";
import AddressCell from "../../components/address-cell";
import {useAddressService} from "../../services/address-service";
import {useContactService} from "../../services/contact-service";
import BankAccountCell from "../../components/bank-account-cell";
import AddEditBankAccountModal from "./add-edit-bank-account-modal";


export default function Profile () {
  let auth = useAuth();
  let userService = useUserService();
  let countryService = useCountryService();
  let timezoneService = useTimezoneService();
  let addressService = useAddressService();
  let contactService = useContactService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [model, setModel] = useState();
  const [countriesList, setCountriesList] = useState([]);
  const [timezonesList, setTimezonesList] = useState([]);

  const formSchema = userProfileRequestSchema;
  const addEditContactModal = useRef();
  const addEditAddressModal = useRef();
  const addEditBankAccountModal = useRef();

  useEffect(()=>{
    let promises = [
      userService.getProfile(),
      countryService.getList(),
      timezoneService.getList()
    ];

    Promise.all(promises).then(([user=null, countries=[], timezones=[]])=>{
      setModel(user);
      setCountriesList(countries);
      setTimezonesList(Object.values(timezones));
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
    });
  }, []);

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    userService.editProfile(values)
      .then((user) => {
        auth.setCurrentUser(user);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{setSubmitting(false);});
  };

  const onAddEditContactCallback = (item)=>{
    let newModel = {...model};
    newModel.contacts = [...HelperService.addOrReplaceItemInList(newModel.contacts, item)];
    setModel(newModel);
  };

  const onAddEditAddressCallback = (item)=>{
    let newModel = {...model};
    newModel.addresses = [...HelperService.addOrReplaceItemInList(newModel.addresses, item)];
    setModel(newModel);
  };

  const onAddEditBankAccountCallback = (item)=>{
    let newModel = {...model};
    newModel.bank_accounts = [...HelperService.addOrReplaceItemInList(newModel.bank_accounts, item)];
    setModel(newModel);
  };

  const delAddress = (item) => {
    if (true===confirm('Odstrániť adresu?')){
      addressService.delModel(item.id)
        .then(()=>{
          let newModel = {...model};
          newModel.addresses = [...HelperService.removeItemFromList(newModel.addresses, item)];
          setModel(newModel);
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const delContact = (item) => {
    if (true===confirm('Odstrániť kontakt?')){
      contactService.delModel(item.id)
        .then(()=>{
          let newModel = {...model};
          newModel.contacts = [...HelperService.removeItemFromList(newModel.contacts, item)];
          setModel(newModel);
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const delBankAccount = (item) => {
    if (true===confirm('Odstrániť bankový účet?')){
      bankAccountService.delModel(item.id)
        .then(()=>{
          let newModel = {...model};
          newModel.bank_accounts = [...HelperService.removeItemFromList(newModel.bank_accounts, item)];
          setModel(newModel);
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  return (
    <>
      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-3">

          <PageTitle>Môj účet</PageTitle>

          <AddEditContactModal ref={addEditContactModal} onSuccess={(item)=>onAddEditContactCallback(item)} />
          <AddEditAddressModal ref={addEditAddressModal} onSuccess={(item)=>onAddEditAddressCallback(item)} />
          <AddEditBankAccountModal ref={addEditBankAccountModal} onSuccess={(item)=>onAddEditBankAccountCallback(item)} />

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  {!model && <Loading className="m-2" />}

                  {model && <Formik
                    enableReinitialize={true}
                    initialValues={formSchema.cast(model)}
                    validationSchema={formSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting, errors, touched }) => (
                      <Form className="row">

                        <FormGroup
                          name="login"
                          placeholder="Váš prihlasovací údaj"
                          label="Login"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="password"
                          type="password"
                          placeholder="Vyplňte pre zmenu hesla"
                          label="Nové heslo"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="password_confirmation"
                          type="password"
                          placeholder="Vyplňte pre zmenu hesla"
                          label="Zopakovať heslo"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="locale"
                          type="select"
                          options={Object.values(LocaleList)}
                          optionLabel="title"
                          optionKey="val"
                          placeholder="Jazyk"
                          label="Jazyk"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="timezone"
                          type="select"
                          options={timezonesList}
                          optionLabel="title"
                          optionKey="id"
                          placeholder="Časová zóna"
                          label="Časová zóna"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <hr />

                        <FormGroup
                          name="title_before"
                          placeholder="titul"
                          label="Titul pred menom"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="first_name"
                          placeholder="Vaše meno"
                          label="Meno"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="last_name"
                          placeholder="Vaše priezvisko"
                          label="Priezvisko"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="title_after"
                          placeholder="titul"
                          label="Titul za menom"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="nationality"
                          type="select"
                          options={countriesList}
                          optionLabel="title"
                          optionKey="code"
                          placeholder="Státna príslušnosť"
                          label="Státna príslušnosť"
                          className="col-md-3"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                            name="birth_number"
                            placeholder="Rodné číslo"
                            label="Rodné číslo"
                            className="col-md-3"
                            touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                            name="birth_at"
                            type="date"
                            placeholder="Dátum narodenia"
                            label="Dátum narodenia"
                            className="col-md-3"
                            touched={touched} errors={errors} schema={formSchema}
                        />

                        <hr />

                        <FormGroup
                            name="company"
                            placeholder="Názov spoločnosti"
                            label="Spoločnosť"
                            className="col-md-4"
                            touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                            name="company_number"
                            placeholder="IČO"
                            label="IČO"
                            className="col-md-4"
                            touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                            name="tax_id"
                            placeholder="DIČ"
                            label="DIČ"
                            className="col-md-4"
                            touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                            name="dph_id"
                            placeholder="IČDPH"
                            label="IČDPH"
                            className="col-md-4"
                            touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                            name="company_registration"
                            placeholder="Zapísane v ..."
                            label="Registrácia"
                            className="col-md-4"
                            touched={touched} errors={errors} schema={formSchema}
                        />

                        <div className="clearfix"></div>

                        <div className="col-sm-12 col-md-6">
                          <h5>Adresy</h5>
                          {!model.addresses?.length>0 && <p className='text-muted'>Pridajte adresy ku používateľovi. Prvú adresu môžete <span className="clickable link-primary text-decoration-underline" onClick={()=>addEditAddressModal.current.openModal(null, "App\\Models\\User", model.id)}>vytvoriť tu</span>.
                          </p>}
                          {model.addresses?.length>0 && <div className="row">{model.addresses?.map((address)=>{
                            return (<div className="col-md-6" key={address.id}>
                              <AddressCell className="col-sm-12"
                                           address={address}
                                           edit={()=>addEditAddressModal.current.openModal(address, "App\\Models\\User", model.id)}
                                           del={()=>delAddress(address)}
                                           onSuccess={(c)=>onAddEditAddressCallback(c)} />
                            </div>)
                          })}
                            <br />
                            <div className="text-center mt-2">
                              <button className='btn btn-outline-secondary' onClick={()=>addEditAddressModal.current.openModal(null, "App\\Models\\User", model.id)}><span className="mdi mdi-plus-circle"></span> Pridať</button>
                            </div>
                          </div>}
                        </div>

                        <div className="col-sm-12 col-md-6">
                          <h5>Kontakty</h5>
                          {!model.contacts?.length>0 && <p className='text-muted'>Pridajte kontakty ku používateľovi. Prvý kontakt môžete <span className="clickable link-primary text-decoration-underline" onClick={()=>addEditContactModal.current.openModal(null, "App\\Models\\User", model.id)}>vytvoriť tu</span>.
                          </p>}
                          {model.contacts?.length>0 && <div className="row">{model.contacts?.map((contact)=>{
                            return (<div className="col-md-6" key={contact.id}>
                              <ContactCell className="col-sm-12"
                                           contact={contact}
                                           edit={()=>addEditContactModal.current.openModal(contact, "App\\Models\\User", model.id)}
                                           del={()=>delContact(contact)}
                                           onSuccess={(c)=>onAddEditContactCallback(c)} />
                            </div>)
                          })}
                            <br />
                            <div className="text-center mt-2">
                              <button className='btn btn-outline-secondary' onClick={()=>addEditContactModal.current.openModal(null, "App\\Models\\User", model.id)}><span className="mdi mdi-plus-circle"></span> Pridať</button>
                            </div>
                          </div>}
                        </div>

                        <div className="col-sm-12 col-md-6">
                          <h5>Bankové účty</h5>
                          {!model?.bank_accounts?.length>0 && <p className='text-muted'>Pridajte bankové účty k používateľovi. Prvý bankový účet môžete <span className="clickable link-primary text-decoration-underline" onClick={()=>addEditBankAccountModal.current.openModal(null, model.id)}>vytvoriť tu</span>.
                          </p>}
                          {model?.bank_accounts?.length>0 && <div className="row">{model.bank_accounts?.map((bankAccount)=>{
                            return (<div className="col-md-12" key={bankAccount.id}>
                              <BankAccountCell className="col-sm-12"
                                               bankAccount={bankAccount}
                                               edit={()=>addEditBankAccountModal.current.openModal(bankAccount, model.id)}
                                               del={()=>delBankAccount(bankAccount)}
                                               onSuccess={(c)=>onAddEditBankAccountCallback(c)} />
                            </div>)
                          })}
                            <br />
                            <div className="text-center mt-2">
                              <button type="button" className='btn btn-outline-secondary' onClick={()=>addEditBankAccountModal.current.openModal(null, model.id)}><span className="mdi mdi-plus-circle"></span> Pridať</button>
                            </div>
                          </div>}
                        </div>

                        <div className="clearfix"></div>

                        <div className={"text-center mt-2"}>
                          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Odoslať</button>
                        </div>
                      </Form>
                    )}
                  </Formik>}

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

Profile.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

Profile.getSEO = function getSEO() {
  return {
    title: "Môj účet",
  }
}
